export default __webpack_public_path__ + "static/media/pizzakit_hover.441801a0.png";